import { render } from "./NumberOfTickets.vue?vue&type=template&id=bd226ac0&ts=true"
import script from "./NumberOfTickets.vue?vue&type=script&lang=ts"
export * from "./NumberOfTickets.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__